/**
 * Slider team script
 */
class Bookero_SliderTeam {
  constructor(wrapper) {
    this.sliderWrapper = wrapper;
    this.initState();
    this.initEvents();
  }

  initState () {
    this.dots = this.sliderWrapper.find('.dot');
    this.prevBtn = this.sliderWrapper.find('.prev');
    this.nextBtn = this.sliderWrapper.find('.next');
    this.list = this.sliderWrapper.find('.slider-team-list');
    this.items = this.list.find('.slider-team-item');
    this.itemsPerPage = 4;
    this.currentItem = 0;
    this.animationInProgress = false;
  }

  initEvents () {
    this.initRWD();
    this.initUI();
  }

  initUI () {
      this.swipeEffect = new Hammer(this.sliderWrapper[0]);

      for (let i = 0; i < this.dots.length; i++) {
          this.dots.eq(i).on('click', e => {
              e.preventDefault();

              if (this.animationInProgress) {
                  return;
              }

              this.currentItem = i;
              this.animationInProgress = true;
              this.dots.removeClass('is-active');
              this.dots.eq(this.currentItem).addClass('is-active');

              this.items.addClass('is-hidden');
              this.list.css('margin-left', (-(100) * this.currentItem) + "%");

              setTimeout(() => {
                  this.animationInProgress = false;
              }, 100);
          });
      }

      this.nextBtn.on('click', e => {
          e.preventDefault();

          if (this.animationInProgress) {
              return;
          }

          this.currentItem++;
          this.animationInProgress = true;

          if (this.currentItem >= (this.items.length / this.itemsPerPage)) {
              this.currentItem = 0;
          }

          this.dots.removeClass('is-active');
          this.dots.eq(this.currentItem).addClass('is-active');
          this.list.css('margin-left', (-100 * this.currentItem) + "%");

          setTimeout(() => {
              this.animationInProgress = false;
          }, 550);
      });


      this.prevBtn.on('click', e => {
          e.preventDefault();

          if (this.animationInProgress) {
              return;
          }

          this.currentItem--;
          this.animationInProgress = true;

          if (this.currentItem < 0) {
              this.currentItem = ((this.items.length / this.itemsPerPage) - 1);
          }

          this.dots.removeClass('is-active');
          this.dots.eq(this.currentItem).addClass('is-active');
          this.list.css('margin-left', (-100 * this.currentItem) + "%");

          setTimeout(() => {
              this.animationInProgress = false;
          }, 550);
      });

      this.swipeEffect.on('swipe', ev => {
          if (ev.type === 'swipe' && ev.direction === 2) {
              if (this.currentItem < this.dots.length - 1) {
                  this.currentItem++;
              } else {
                  this.currentItem = 0;
              }

              this.dots.eq(this.currentItem).trigger('click');
          }

          if (ev.type === 'swipe' && ev.direction === 4) {
              if (this.currentItem > 0) {
                  this.currentItem--;
              } else {
                  this.currentItem = this.dots.length - 1;
              }

              this.dots.eq(this.currentItem).trigger('click');
          }
      });
  }

  initRWD () {
      let desktopViewport = window.matchMedia('(min-width: 1200px)');
      let tabletViewport = window.matchMedia('(min-width: 840px) and (max-width: 1199px)');
      let smallTabletViewport = window.matchMedia('(min-width: 560px) and (max-width: 839px)');
      let mobileViewport = window.matchMedia('(max-width: 559px)');

      if (desktopViewport.matches) {
        this.itemsPerPage = 4;
      } else if (tabletViewport.matches) {
        this.itemsPerPage = 3;
      } else if (smallTabletViewport.matches) {
        this.itemsPerPage = 2;
      } else if (mobileViewport.matches) {
        this.itemsPerPage = 1;
      }

      this.toggleDotsVisibility();

      desktopViewport.addListener(mq => {
          if (mq.matches) {
              this.setItemsPerPage(3);
          }
      });

      tabletViewport.addListener(mq => {
          if (mq.matches) {
              this.setItemsPerPage(2);
          }
      });

      mobileViewport.addListener(mq => {
          if (mq.matches) {
              this.setItemsPerPage(1);
          }
      });
  }

  setItemsPerPage (numberOfItems) {
      this.currentItem = 0;
      this.itemsPerPage = numberOfItems;
      this.dots.removeClass('is-active');
      this.dots.eq(this.currentItem).addClass('is-active');
      this.list.css('margin-left', (-100 * this.currentItem) + "%");
      this.toggleDotsVisibility();
  }

  toggleDotsVisibility () {
      let visibleDots = Math.ceil(this.items.length / this.itemsPerPage);

      for (let i = 0; i < this.dots.length; i++) {
          let visibilityState = i <= visibleDots - 1 ? 'block' : 'none';
          this.dots.eq(i).css('display', visibilityState);
      }
  }
}
